const media = (name, title) => ({
  src: `/einsatz/coeur-pulse/${name}.png`,
  title,
  alt: title,
  inlineTitle: null,
  inlineLabel: null,
});

export const COEUR_PULSE_CONTENT = {
  title: 'COEUR PULSE',
  subtitle: 'COEUR PULSE – Gebrauchsanleitung',
  source: 'Stand: 09.11.2023',
  referenceDocument: {
    label: 'Original-PDF herunterladen',
    href: '/einsatz/coeur-pulse/coeur-pulse.pdf',
    filename: 'COEUR PULSE.pdf',
  },
  sections: [
    {
      id: 'coeur-allgemein',
      title: 'Allgemein',
      media: {
        ...media('allgemein', 'COEUR PULSE – Produktübersicht, Warnung und Kennzeichnung'),
        maxWidth: 408,
      },
    },
    {
      id: 'coeur-anwendungsbereich',
      title: '1. Anwendungsbereich',
      blocks: [
        {
          paragraphs: [
            'Benutzen Sie diese Ausrüstung nicht zum Hochziehen von Lasten.',
            'Dieses Produkt darf nicht über seine Grenzen hinaus belastet werden. Es darf ausschließlich zu dem Zweck verwendet werden, für den es entwickelt wurde.',
          ],
        },
        {
          heading: 'COEUR PULSE 12 mm',
          paragraphs: [
            '- EN 795: 2012 Typ B: Entfernbare Anschlageinrichtung mit Verriegelung, darf nur von einer Person benutzt werden. Persönliche Schutzausrüstung (PSA) zum Schutz gegen Absturz.',
            '- GB 30862-2014 Typ B: Entfernbare Anschlageinrichtung mit Verriegelung, für die Benutzung durch zwei Personen.',
            '- Anschlageinrichtung gemäß CEN/TS 16415: Verwendung durch zwei Personen.',
            '- EN 959: 2018: Verankerung für den Einsatz am Felsen, Klasse 2, Außenbereich, Umgebungen, die keine Spannungsrisskorrosion verursachen.',
          ],
        },
        {
          heading: 'Haftung',
          paragraphs: [
            { text: 'WARNUNG\nAktivitäten, bei denen diese Ausrüstung zum Einsatz kommt, sind naturgemäß gefährlich.\nFür Ihre Handlungen, Entscheidungen und für Ihre Sicherheit sind Sie selbst verantwortlich.', strong: true },
            'Vor dem Gebrauch dieser Ausrüstung müssen Sie:',
            '- die Gebrauchsanleitung vollständig gelesen und verstanden haben,',
            '- fachgerecht zur richtigen Benutzung der Ausrüstung ausgebildet sein,',
            '- sich mit Ihrer Ausrüstung vertraut machen, die Möglichkeiten und Grenzen kennen lernen,',
            '- die mit dem Einsatz verbundenen Risiken verstehen und akzeptieren.',
            { text: 'Die Nichtberücksichtigung auch nur einer dieser Warnungen kann zu schweren Verletzungen oder sogar Tod führen.', strong: true },
            'Dieses Produkt darf nur von kompetenten und verantwortungsbewussten Personen verwendet werden oder von Personen, die unter der direkten Aufsicht und visuellen Kontrolle einer kompetenten und verantwortungsbewussten Person stehen.',
            'Sie sind für Ihre Handlungen, Entscheidungen und für Ihre Sicherheit verantwortlich und tragen die Konsequenzen. Wenn Sie nicht in der Lage sind, diese Verantwortung zu übernehmen, oder wenn Sie die Gebrauchshinweise nicht richtig verstanden haben, benutzen Sie diese Ausrüstung nicht.',
          ],
        },
      ],
    },
    {
      id: 'coeur-benennung',
      title: '2. Benennung der Teile',
      layout: 'illustrated',
      media: media('benennung', 'COEUR PULSE – nummerierte Bauteile'),
      blocks: [
        {
          paragraphs: [
            '(1) Bohrhakenlasche, (2) Bohrhaken, (3) Blockierkonus, (4) Bewegliche Blockierteile, (5) Verriegelbarer Entsperrkolben, (6) Dichtung.',
            'Hauptmaterialien: rostfreier Stahl, Aluminium.',
            'Bohrlasche 12-mm-Ausführung: rostfreier Stahl (316L).',
          ],
        },
      ],
    },
    {
      id: 'coeur-ueberpruefung',
      title: '3. Überprüfung, zu kontrollierende Punkte',
      layout: 'illustrated',
      media: media('ueberpruefung', 'COEUR PULSE – Hinweise zur PSA-Überprüfung'),
      blocks: [
        {
          paragraphs: [
            'Ihre Sicherheit hängt vom Zustand Ihrer Ausrüstung ab.',
            'Petzl empfiehlt, mindestens alle 12 Monate (entsprechend den in Ihrem Land geltenden Vorschriften und den Nutzungsbedingungen) eine eingehende Überprüfung durch eine kompetente Person durchführen zu lassen. Achtung: Abhängig von der Gebrauchsintensität muss Ihre PSA gegebenenfalls häufiger überprüft werden. Bitte beachten Sie die auf Petzl.com beschriebenen Vorgehensweisen. Tragen Sie die Ergebnisse in den Prüfbericht Ihrer PSA ein: Typ, Modell, Kontaktinformationen des Herstellers, Seriennummer oder individuelle Nummer, Daten: Herstellung, Kauf, erste Anwendung, nächste regelmäßige Überprüfung, Probleme, Bemerkungen, Name und Unterschrift des Prüfers.',
            'Wir empfehlen, das Datum der nächsten Überprüfung auf dem Produkt zu vermerken.',
          ],
        },
        {
          heading: 'Vor jedem Einsatz',
          paragraphs: [
            'Überprüfen Sie den Zustand der Verankerung (Lasche, Bohrhaken, Blockierteile, Entsperrkolben): Beschädigung der Oberfläche, Verformungen, Risse, Abnutzungs- und Korrosionserscheinungen.',
            'Überprüfen Sie den Zustand des Blockierkonus: Beschädigung der Oberfläche, Verformungen, Risse, Abnutzungs- und Korrosionserscheinungen.',
            'Vergewissern Sie sich, dass der Entsperrkolben und die Rückholfeder einwandfrei funktionieren und nicht verschmutzt sind. Vergewissern Sie sich, dass die beweglichen Blockierteile problemlos über den Blockierkonus gleiten. Vergewissern Sie sich, dass die Verriegelung des Kolbens einwandfrei funktioniert (mit einem neuen Produkt vergleichen).',
          ],
        },
        {
          heading: 'Während des Gebrauchs',
          paragraphs: [
            'Es ist unerlässlich, den Zustand des Produkts und seiner Verbindungen mit anderen Ausrüstungsgegenständen im System regelmäßig zu überprüfen. Stellen Sie stets sicher, dass die einzelnen Ausrüstungsgegenstände im System richtig zueinander positioniert sind.',
          ],
        },
      ],
    },
    {
      id: 'coeur-kompatibilitaet',
      title: '4. Kompatibilität',
      layout: 'illustrated',
      media: media('kompatibilitaet', 'COEUR PULSE – Kompatibilität und Herstellerhinweise'),
      blocks: [
        {
          paragraphs: [
            'Überprüfen Sie die Kompatibilität dieses Produkts mit den anderen Elementen Ihres Systems (Kompatibilität = funktionelles Zusammenspiel).',
            'Der mit der Lasche verwendete Karabiner muss mit den in Ihrem Land geltenden Normen übereinstimmen (Karabiner EN 362 oder EN 12275 entsprechend dem Einsatzbereich).',
            'Der COEUR PULSE 12 mm ist ausschließlich mit der Lasche COEUR STAINLESS 12 mm kompatibel.',
          ],
        },
      ],
    },
    {
      id: 'coeur-setzen',
      title: '5. Setzen des Bohrhakens',
      blocks: [
        {
          mediaGallery: [
            media('setzen', 'COEUR PULSE – Setzen, Installationskontrolle und Entfernen'),
            media('setzen-hinweise', 'COEUR PULSE – Abstände und Warnhinweise zur Installation'),
          ],
        },
        {
          paragraphs: [
            'Überprüfen Sie die Qualität des Untergrunds im Bereich der Verankerung.',
            'Vergewissern Sie sich, dass der Fels kompakt und homogen ist.',
            'a. Nachdem Sie den zu bohrenden Bereich gesäubert haben, bohren Sie ein Loch unter Beachtung des Ihrem Bohrhakenmodell entsprechenden Durchmessers und der Mindestbohrtiefe:',
            '- Bohrtiefe 65 mm bei einem Durchmesser von 12 mm.',
            { text: 'Um ein rundes Loch zu bohren, verwenden Sie einen geraden Bohrer mit drei oder vier Schneiden.', strong: true },
            'Wenn Sie viel Kraft aufwenden müssen, um den Bohrhaken zu setzen, dann ist das Loch nicht rund: Verwenden Sie dieses Loch nicht.',
            'Bohren Sie im rechten Winkel zur Felsoberfläche und versuchen Sie nicht, das Loch mit dem Bohrer zu vergrößern.',
            'Verwenden Sie ausschließlich einen Gesteinbohrer mit metrischen Abmessungen, Achtung bei der Zollumrechnung.',
            'Das Loch kann auch durch Kernbohrung gemacht werden.',
            'Achtung: Wenn Sie ein bereits vorhandenes Loch verwenden, überprüfen Sie dessen Zustand und Abmessungen.',
            'b. Säubern Sie das Bohrloch mit einer Bürste und anschließend mit einem Ausbläser. Das Loch muss innen trocken sein. Achten Sie besonders auf eventuelle Fettspuren.',
            'c. Ziehen Sie am Kolben, um den Bohrhaken einsetzen zu können. Drücken Sie die Lasche an den Fels. Lassen Sie den Kolben los und verriegeln Sie ihn.',
            'Durch die Verriegelung des Kolbens werden Fehlbedienungen, die zur Entsperrung führen können, ausgeschlossen. Die Bruchlast der Verankerung wird hiervon nicht berührt.',
            'd. Installationstest:',
            'Vergewissern Sie sich nach jeder Installation, dass der Haken fest im Bohrloch sitzt.',
            'Stellen Sie sicher, dass zwischen Fels und Bohrhaken kein Spiel ist.',
            { text: 'Kontrolle der Installation: Stellen Sie sicher, dass der Kolben die Bohrlasche nicht berührt (Zeichen, dass das Loch zu groß ist, Risiko, dass die Verankerung nicht richtig hält).', strong: true },
            'Achtung: Die Verriegelung des Kolbens sagt nichts über die Qualität der Verankerung aus.',
            'Vergewissern Sie sich, dass das Drehen der Lasche nicht beeinträchtigt ist.',
            'Entfernen:',
            'Entsperren Sie den Kolben, um den Anker herausziehen zu können. Überprüfen Sie den Bohrhaken vor jedem neuen Einsatz.',
          ],
        },
      ],
    },
    {
      id: 'coeur-bruchlast',
      title: '6. Bruchlast',
      layout: 'illustrated',
      media: media('bruchlast', 'COEUR PULSE – Bruchlast und Untergrundqualität'),
      blocks: [
        {
          paragraphs: [
            'Die angegebenen Bruchwerte wurden in Beton 50 MPa (Beton von sehr guter Qualität oder Fels) und 25 MPa (normaler Beton) ermittelt.',
            'Die Bruchlast der Verankerung ist von der Qualität des Untergrunds und der Installation abhängig.',
            { text: 'Warnung: Die Auszugsfestigkeit kann bei einem falsch gesetzten Anker und/oder ungeeigneten Untergrund nahe Null liegen.', strong: true },
            'Warnung: In weichem Fels reduziert sich die Zugfestigkeit der Verankerung. Möglicherweise muss ein längerer oder ein anderer Anker verwendet und die Zugfestigkeit in Tests überprüft werden.',
            'Wenn Sie nach dem Setzen des Ankers Zweifel an der Zugfestigkeit der Verankerung haben, führen Sie einen Ausreißtest mit einer Kraft von maximal 6 kN (COEUR PULSE 12 mm) durch.',
          ],
        },
      ],
    },
    {
      id: 'coeur-vorsichtsmassnahmen',
      title: '7. Vorsichtsmaßnahmen',
      layout: 'illustrated',
      media: media('vorsichtsmassnahmen', 'COEUR PULSE – Positionierung, Redundanz und Verformung'),
      blocks: [
        {
          heading: 'Bleiben Sie unterhalb der Verankerung:',
          paragraphs: [
            { text: 'COEUR PULSE 12mm wurde für eine Verwendung unterhalb der Verankerung konzipiert.', strong: true },
            'Identifizierte Hauptrisiken, wenn der Anwender sich oberhalb der Verankerung befindet:',
            '- Falschpositionierung der Ausrüstung (Verbindungselement, Seil, Riemen, Expressset usw.), die sich dann über den Entsperrkolben legt.',
            '- Drehen der Lasche, wodurch die Platzierung der Materialien während der Verwendung verändert werden kann (zum Beispiel Drehen des Expresssets, wodurch das Risiko des Aushängens während eines Sturzes erhöht wird).',
          ],
        },
        {
          heading: 'Beachten Sie das Redundanzprinzip:',
          paragraphs: ['Verwenden Sie mindestens zwei voneinander unabhängige Anschlagpunkte.'],
        },
        {
          heading: 'Verformungswerte:',
          paragraphs: ['Maximale Belastung vor Verformung: Belastungen ab 6 kN (COEUR PULSE 12 mm) führen zu einer bleibenden Verformung des Bohrhakens.'],
        },
        {
          heading: 'Verformungsrisiko des Kolbens:',
          paragraphs: ['Wenn der Kolben bedeckt ist oder belastet wird, kann er sich bereits bei 2 kN verformen, wodurch das Produkt nicht mehr brauchbar ist und sich nur schwer vom Untergrund entfernen lässt.'],
        },
      ],
    },
    {
      id: 'coeur-zusatzinformationen',
      title: '8. Zusätzliche Informationen',
      blocks: [
        {
          mediaGallery: [
            media('zusatzinformationen', 'COEUR PULSE – Lebensdauer, Pflege, Lagerung und weitere Informationen'),
            media('kennzeichnung', 'COEUR PULSE – Rückverfolgbarkeit und Produktkennzeichnung'),
          ],
        },
        {
          paragraphs: [
            'Das Produkt entspricht der PSA-Verordnung (EU) 2016/425. Die EU-Konformitätserklärung ist auf Petzl.com verfügbar.',
            '- Vermeiden Sie jeglichen Einsatz in Meeresnähe oder korrosiver Umgebung über einen längeren Zeitraum.',
            '- Wenn eine Anschlageinrichtung als Bestandteil eines Auffangsystems verwendet wird, muss ein Hilfsmittel verfügbar sein, mit dem sich die beim Auffangen eines Sturzes auf den Anwender einwirkenden maximalen dynamischen Kräfte auf einen Wert von maximal 6 kN reduzieren lassen.',
            '- Die maximale Belastung, die von der Anschlageinrichtung auf die Struktur übertragen werden kann, liegt bei 12 kN.',
            '- Bei der Installation eines Bohrhakens an einem Felsen in Meeresnähe oder in einer anderen stark korrosiven Umgebung über einen längeren Zeitraum reduziert sich die Lebensdauer der Verankerung erheblich.',
            '- Der Anwender muss für eventuelle Schwierigkeiten, die während der Anwendung dieses Produkts auftreten können, Rettungsmöglichkeiten planen.',
            '- Der Anschlagpunkt des Systems sollte oberhalb der Position des Anwenders errichtet werden und den Anforderungen der Norm EN 795 entsprechen. Die Mindestbruchlast des Anschlagpunktes muss 12 kN betragen.',
            '- In einem Auffangsystem ist vor jeder Benutzung sicherzustellen, dass genügend Sturzraum unter dem Anwender vorhanden ist, sodass er im Falle eines Sturzes nicht auf den Boden oder auf ein Hindernis schlägt.',
            '- Achten Sie darauf, dass der Fixpunkt richtig platziert ist, um das Risiko und die Höhe eines Sturzes zu reduzieren.',
            '- In einem Auffangsystem ist zum Halten des Körpers ausschließlich ein Auffanggurt zulässig.',
            '- Werden mehrere Ausrüstungsgegenstände zusammen verwendet, kann es zu gefährlichen Situationen kommen, wenn die Sicherheitsfunktion eines Gegenstands durch einen anderen Ausrüstungsgegenstand behindert wird.',
            '- ACHTUNG – GEFAHR: Achten Sie darauf, dass die Produkte nicht an rauen Materialien oder scharfkantigen Gegenständen reiben.',
            '- Anwender müssen für Aktivitäten in der Höhe gesundheitlich in guter Verfassung sein. WARNUNG: Das regungslose Hängen in einem Gurt kann zu schweren Verletzungen oder sogar Tod führen (Hängetrauma!).',
            '- Die Gebrauchsanleitungen für jeden Ausrüstungsgegenstand, der zusammen mit diesem Produkt verwendet wird, müssen unbedingt befolgt werden.',
            '- Die Gebrauchsanleitungen müssen allen Anwendern dieser Ausrüstung in Landessprache zur Verfügung gestellt werden.',
            '- Bewahren Sie die Gebrauchsanleitung sorgfältig in einem Ordner als künftige Referenz auf, nachdem Sie sie von der Ausrüstung entfernt haben.',
            '- Vergewissern Sie sich, dass die Markierungen auf dem Produkt lesbar sind.',
          ],
        },
        {
          heading: 'Aussondern von Ausrüstung:',
          paragraphs: [
            'ACHTUNG: Außergewöhnliche Umstände können die Aussonderung eines Produkts nach einer einmaligen Anwendung erforderlich machen (Art und Intensität der Benutzung, Anwendungsbereich: aggressive Umgebungen, Meeresklima, scharfe Kanten, extreme Temperaturen, Chemikalien usw.).',
            'In folgenden Fällen muss ein Produkt ausgesondert werden:',
            '- Seine Lebensdauer wurde überschritten.',
            '- Es wurde einem schweren Sturz oder einer schweren Belastung ausgesetzt.',
            '- Das Produkt fällt bei der PSA-Überprüfung durch. Sie bezweifeln seine Zuverlässigkeit.',
            '- Die vollständige Gebrauchsgeschichte ist nicht bekannt (z. B. ist eine Produktmarkierung unleserlich).',
            '- Das Produkt ist veraltet (z. B. Änderung der gesetzlichen Bestimmungen, der Normen und der technischen Vorschriften, Inkompatibilität mit anderen Ausrüstungsgegenständen usw.).',
            'Zerstören und entsorgen Sie diese Produkte, um ihren weiteren Gebrauch zu verhindern.',
          ],
        },
        {
          heading: 'Zeichenerklärungen:',
          paragraphs: [
            { text: 'A. Unbegrenzte Lebensdauer – B. Temperaturbeständigkeit – C. Vorsichtsmaßnahmen – D. Reinigung – E. Trocknung – F. Lagerung/Transport – G. Pflege – H. Änderungen/Reparaturen (außerhalb der Petzl-Betriebsstätten nicht zulässig, ausgenommen Ersatzteile) – I. Fragen/Kontakt', strong: true },
          ],
        },
        {
          heading: '3 Jahre Garantie',
          paragraphs: [
            'Auf Material- und Fabrikationsfehler. Von der Garantie ausgeschlossen sind: normale Abnutzung, Oxidation, Modifikationen oder Nachbesserungen, unsachgemäße Lagerung, unsachgemäße Wartung, Nachlässigkeit und Anwendungen, für die das Produkt nicht bestimmt ist.',
          ],
        },
        {
          heading: 'Warnhinweise',
          paragraphs: [
            '1. Unmittelbare Verletzungs- oder Lebensgefahr. 2. Potenzielles Unfall- oder Verletzungsrisiko. 3. Wichtige Information über die Funktionsweise oder die Leistungsangaben Ihres Produkts. 4. Inkompatibilität zwischen Ausrüstungsgegenständen.',
          ],
        },
        {
          heading: 'Rückverfolgbarkeit und Markierung',
              paragraphs: [
                'a. Hersteller – b. Individuelle Nummer – c. Herstellungsjahr – d. Herstellungsmonat – e. Nummer der Fertigungsreihe – f. Individuelle Produktnummer – g. Modell-Identifizierung – h. Rückverfolgbarkeit: Data Matrix – i. Verriegelungsrichtung – j. Normen – k. Nummer der Fertigungsreihe der Lasche – l. Herstellungsjahr der Lasche – m. Quartal – n. Lesen Sie die Gebrauchsanleitung aufmerksam durch – o. Durchmesser – p. Rostfreier Stahl 316L – q. Scherfestigkeit – r. Nur ein Anwender – s. Entspricht den Anforderungen der PSA-Verordnung. Benannte Stelle für die EU-Baumusterprüfung – t. Nummer der notifizierten Stelle für die Produktionskontrolle dieser PSA – u. Bohrhakenklasse – v. Zwei Anwender',
              ],
        },
      ],
    },
  ],
};
